<template>
  <div class="nodalBlock">
    <p>{{ pairedRecord.message }}</p>
    <p class="text-muted text-right">{{ printDate(pairedRecord.date) }}</p>
    <div>
      <form @submit.prevent="makePair">
        <div class="form-group">
          <label for="">Комментарий к оплате</label>
          <input type="text" required v-model="comment" placeholder="детали оплаты" class="form-control">
        </div>
        <UploadImages ref="images"/>

        <div class="text-right">
          <LoadingButton
            title="Привязать оплату"
            className="btn btn-success"
            type="submit"
            :onClick="() => {}"
            :loading="loading"
            color="white"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import bankSMSList from "@/views/admin/sms/bankSMSList";
import api from "@/api";
import UploadImages from "@/components/uploads/UploadImages";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  props: ['order', 'cardId', 'closeDrawer', 'pairedRecord', 'onAccept', 'updateData'],
  components: {
    bankSMSList,
    UploadImages,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      comment: null,
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  watch: {
    'pairedRecord': {
      handler: function (val, oldVal) {
        this.setPairRecord()
      },
      deep: true
    },
  },
  created() {
    this.setPairRecord();
  },
  methods: {
    async makePair() {
      // console.log(this.pairedRecord, this.order);
      if (this.pairedRecord.sum !== this.order.no_cash_price) {

        // return;
      }
      this.loading = true;
      const {data} = await api.post('/new/orders/updateByAction', {
        action: 'addPrePaidData',
        order_id: this.order.id,
        comment: this.comment,
        record: this.pairedRecord,
        files: this.$refs.images.uploadedFiles.filter((f) => !f.to_delete)
      })
      if (data.success) {
        toastr['success']('Сохранено');
        if (this.updateData) {
          this.updateData();
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    },
    setPairRecord() {
      if (!this.pairedRecord.message) return;
      if (this.pairedRecord.message.includes('Перевод')
        || this.pairedRecord.message.includes('зачисление')
      ) {
        const m = this.pairedRecord.message.split('.');
        this.comment = m[0];
      } else {
        this.comment = this.pairedRecord.message;
      }
    },
  }
}

</script>

<style scoped>
.nodalBlock .main-content {
  padding: 0;
}
</style>
